<template>
  <div class="profile-show-container">
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
    </div>
    <section class="profile-show-section">
      <div class="profile-show-section__body">
        <div
          v-if="showBoxListAlert"
          class="profile-show-section__box-list-area"
        >
          <div class="box-list--alert profile-show-section__box-list">
            {{ boxListAlertMessage }}
          </div>
        </div>
        <UserProfileContents
          :showable-edit-link="showableEditLink"
          :edit-mypage-profile-path="editMypageProfilePath"
          :profile-icon-image-path="profileIconImagePath"
          :nickname="nickname"
          :birthday-displayable="birthdayDisplayable"
          :birthday-text="birthdayText"
          :description-content="descriptionContent"
          :is-current-user="isCurrentUser"
          :user-id="userId"
          :is-app="isApp"
          :mypage-follows-path="mypageFollowsPath"
          :screen-name="screenName"
        />
      </div>
      <WishListContents
        :is-app="isApp"
        :is-wish-list-item-present="isWishListItemPresent"
        :is-current-user="isCurrentUser"
        :nickname="nickname"
        :edit-limit-path="editLimitPath"
        :edit-order-path="editOrderPath"
        :items-path="itemsPath"
        @reached-limit-error="showReachedLimitError"
      />
    </section>
  </div>
</template>
<script>
import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success.vue'
import UserProfileContents from '../../../components/organism/mypages/profiles/UserProfileContents.vue'
import WishListContents from '../../../components/organism/mypages/profiles/WishListContents.vue'

export default {
  components: {
    FeedbackSuccess,
    UserProfileContents,
    WishListContents
  },
  props: {
    flashMessage: {
      type: String,
      required: false,
      default: ''
    },
    showableEditLink: {
      type: Boolean,
      required: true
    },
    editMypageProfilePath: {
      type: String,
      required: true
    },
    profileIconImagePath: {
      type: String,
      required: true
    },
    nickname: {
      type: String,
      required: true
    },
    birthdayDisplayable: {
      type: Boolean,
      required: true
    },
    birthdayText: {
      type: String,
      required: true
    },
    descriptionContent: {
      type: String,
      required: true
    },
    isCurrentUser: {
      type: Boolean,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    isApp: {
      type: Boolean,
      required: true
    },
    mypageFollowsPath: {
      type: String,
      required: true
    },
    screenName: {
      type: String,
      required: true
    },
    isWishListItemPresent: {
      type: Boolean,
      required: true
    },
    editLimitPath: {
      type: String,
      required: false,
      default: ''
    },
    editOrderPath: {
      type: String,
      required: false,
      default: ''
    },
    itemsPath: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      showableSuccessFeedback: false,
      successMessage: '',
      showBoxListAlert: false,
      boxListAlertMessage: ''
    }
  },
  mounted() {
    if (this.flashMessage && this.flashMessage.length >= 0) {
      this.showFeedback(this.flashMessage)
    }
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    showReachedLimitError() {
      this.showBoxListAlert = true
      this.boxListAlertMessage =
        'お選びいただいたギフトは、受け取りたい数を超えていました。\nお手数ですが別のギフトを選択してください。'
    }
  }
}
</script>
<style lang="scss" scoped>
.profile-show-container {
  box-sizing: border-box;

  .profile-show-section {
    &__body {
      margin: 0 auto 16px;
      padding: 24px 16px;
      background-color: $white;
      box-sizing: border-box;
    }

    &__box-list-area {
      text-align: left;
      max-width: 375px;
      margin: 0 auto 24px;
    }

    &__box-list {
      padding: 16px;
      white-space: break-spaces;
    }
  }
}
</style>
